import { defineStore } from 'pinia';
import { useImage } from '#imports'
import type { Ref } from 'vue';

export const useSeoStore = defineStore('seo', () => {

  const seoImageUrl: Ref<String | null> = ref(null);
  const img = useImage()


  function getSeoImage(productUrl: string = 'https://a.storyblok.com/f/112921/1462x796/eb27c034a1/an-logo-og.png', { width = 1200, height = 630 }: { width?: number, height?: number } = {}, quality: number = 100) {
    const url = img(productUrl, { width, height, quality })
    seoImageUrl.value = url.replace('cover', 'scale-down')
  }

  return {
    getSeoImage,
    seoImageUrl
  }

})
